import { notification } from 'antd';
import axios from 'axios';
import decode from 'jwt-decode';

import { gTagSaida } from '../helpers/googleAnalytics';

/**
 * @description Pega token do localstorage
 */
export const getTokenTMOV = () => localStorage.getItem('access_token');

/**
 * @description Desloga do sistema
 * @param {Navigation} history
 */
export const logout = (history = null) => {
  const eventId = localStorage.getItem('idSessao');
  gTagSaida(
    'Logout',
    'Interação do usuário',
    'Usuário saiu do sistema',
    eventId
  );
  localStorage.clear();
  if (history) {
    history.push('/');
  } else {
    window.location.href = '/';
  }
};

/**
 * @description Notifica o usuário que ele precisa logar novamente
 */
export const notAuthorized = () => {
  notification.warn({
    message: 'Sessão expirada',
    description: 'Entre novamente por favor.',
    duration: 3,
    onClose: logout,
  });
};

/**
 * @description Pegar todas as permissões do usuário
 */
export const getPermissions = () => {
  const accessToken = getTokenTMOV();
  return accessToken ? decode(accessToken).user.permissions : [];
};

/**
 * @description Atualiza o token do usuário
 * @param {Request} originalRequest
 */
export const startRefreshToken = originalRequest => {
  originalRequest._retry = true;
  const refreshToken = localStorage.getItem('refresh_token');
  // Evita inteceptors
  return axios
    .post(`${process.env.REACT_APP_API_AUTH_URL}/refresh-token`, {
      refreshToken,
    })
    .then(({ data }) => {
      localStorage.setItem('access_token', data.token);
      axios.defaults.headers.common.Authorization = `Bearer ${data.token}`;
      originalRequest.headers.Authorization = `Bearer ${data.token}`;
      return axios(originalRequest);
    })
    .catch(notAuthorized);
};
